"use strict";
import PartialFetcher from "./partial_fetcher";
import Refetcher from "./data/entity/refetcher";
import LoadsStore from "../stores/loads_store";
import CarrierInvoicesStore from "../stores/carrier_invoices_store";
import DataStoreService from "./data_store_service";
var LoadsService = function() {
  this._store = LoadsStore;
  this._invoiceStore = CarrierInvoicesStore;
  this.loads = [];
  var self = this;
  self.loads_by_carrier_id = {};
  this.counts = {
    approved: 0
  };
  window.ls = this;
  this.ready = function() {
    if (self.fetched) {
      return Promise.resolve(true);
    } else if (self.fetchingPromise) {
      return self.fetchingPromise;
    } else {
      self.fetchingPromise = Promise.resolve().then(function() {
        return $.get("/api/loads/to_process").then(function(data) {
          self.fetched = true;
          return DataStoreService.updateStores(data);
        });
      });
      return self.fetchingPromise.then(function() {
        self.fetchingPromise = null;
      });
    }
  };
  this.refresh = function() {
    this.fetched = false;
    return this.ready();
  };
  this.allLoads = function() {
    return this._store.items;
  };
  this.approved = function() {
    return _.sortBy(
      _.where(this.allLoads(), { state: "processed" }),
      function(load) {
        var processed_at = load.processed_at;
        if (!processed_at) {
          processed_at = /* @__PURE__ */ new Date("01/01/1900");
        } else {
          processed_at = new Date(processed_at);
        }
        return /* @__PURE__ */ new Date() - processed_at;
      }
    );
  };
  this.partialFetcher = new PartialFetcher(
    this._store,
    function(ids) {
      return $.get(
        "/api/loads/bulk",
        { ids }
      ).then(function(result) {
        return DataStoreService.updateStores(result).loads;
      });
    }
  );
  this.getLoads = function(loadStateIds) {
    return this.partialFetcher.fetchItemsIfNeeded(loadStateIds);
  };
  this.getLoadsByInvoiceIds = function(invoiceIds) {
    var loadStateIds = _.pluck(_.compact(this._invoiceStore.findAll(invoiceIds)), "load_state_id");
    return _.map(loadStateIds, this.getFetchedWithId);
  };
  this.getFetchedWithId = function(loadStateId) {
    return self._store.find(loadStateId);
  };
  this.getLoad = function(loadStateId) {
    return this.getLoads([loadStateId]).then(function(loads) {
      return _.first(loads);
    });
  };
  this.forceGetLoad = function(loadStateId) {
    return this.forceGetLoads([loadStateId]).then(function(loads) {
      return _.first(loads);
    });
  };
  this.forceGetLoads = function(loadStateIds) {
    return this.partialFetcher.fetchItemsIfNeeded(
      loadStateIds,
      (item) => false
    );
  };
  this.loadsUpdated = function() {
    self.counts.approved = self.approved().length;
    $(self).trigger("loads_service:updated");
  };
  $(this._store).on("storeChanged:loadState", this.loadsUpdated);
  this.update = function() {
    this.fetcher.update();
  }.bind(this);
  this.startObservingUpdates = function(handler) {
    $(this).on("loads_service:updated", handler);
  }.bind(this);
  this.stopObservingUpdates = function(handler) {
    $(this).off("loads_service:updated", handler);
  }.bind(this);
  this.fetcher = new Refetcher("/api/loads/updates", DataStoreService.responseHandler);
};
var loadsService = new LoadsService();
export default loadsService;
